import { ResultOf, gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_CARD_FRAGMENT } from '@/components/NarrativeCard';
import { FAIR_VALUE_HISTOGRAM_COMPANY_FRAGMENT } from '../../FairValueHistogram/fairValueHistogramFragment';

const QUERY = gql(
  `
  query CompanyNarrativesWithHistogram($canonicalUrl: String!) {
    company: Company(canonicalURL: $canonicalUrl) {
      id
      uniqueSymbol
      name
      ...FairValueHistogramCompanyFields
    }
    narratives(first: 4, filter: { canonicalUrl: $canonicalUrl }, sort: { field: POPULARITY, direction: DESC }) {
      edges {
        node {
          ...NarrativeCardFields
          id
          company {
            id
            uniqueSymbol
          }
        }
      }
    }
  }
`,
  [NARRATIVE_CARD_FRAGMENT, FAIR_VALUE_HISTOGRAM_COMPANY_FRAGMENT]
);

export const useCompanyNarratives = makeGqlSuspenseQuery(QUERY, {
  tags: ['narrative', 'narrative-company-report-list'],
  staleTime: 0,
});

export type Narrative = ResultOf<
  typeof QUERY
>['narratives']['edges'][number]['node'];
